import React from 'react';
import Navbar from './Navbar';
import Footer from './Footer';

const Layout = ({ children }) => {
  return (
    <div className="min-h-screen flex flex-col relative overflow-hidden">
      {/* Background ambient light effects */}
      <div className="fixed top-0 left-1/4 w-96 h-96 bg-emerald-500/10 rounded-full blur-[120px] pointer-events-none -z-10"></div>
      <div className="fixed bottom-0 right-1/4 w-[30rem] h-[30rem] bg-purple-500/10 rounded-full blur-[150px] pointer-events-none -z-10"></div>
      
      <Navbar />
      <main className="flex-grow max-w-6xl w-full mx-auto px-6 pt-28 pb-16">
        {children}
      </main>
      <Footer />
    </div>
  );
};

export default Layout;